<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.property.selected_property' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="services.length">
    <li class="service-data-picker-list-ele" *ngFor="let service of services">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}">
            <a class="-m-1 block flex-1 p-1 w-full">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectService($event, service)" [checked]="isSelectedService(service)"
                        *ngIf="selectOption === 'multiSelect'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="servicesContent"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectService($event, service)" [checked]="isSelectedService(service)"
                        *ngIf="selectOption === 'select'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="servicesContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full">
                            <ng-container *ngTemplateOutlet="servicesContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #servicesContent>
                        <div class="flex items-center justify-between w-full">
                            <div class="w-10/12">
                                <div class="flex flex-row space-x-2 w-11/12">
                                    <p class="truncate text-lg font-medium text-gray-900 cursor-pointer">
                                        {{service.service_name}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1 w-11/12" *ngIf="service?.service_description">
                                    <p class="truncate text-base text-gray-500"
                                        [innerHTML]="service?.service_description | safeHtml"></p>
                                </div>
                            </div>
                            <div class="w-2/12 flex">
                                <div class="ml-auto mr-4">
                                    <span *ngIf="utilityService.hasPermission('product.show_selling_price') && !utilityService.isEmptyOrUndefined(service?.estimated_price)"
                                        class="truncate text-base text-gray-500">{{service?.estimated_price |
                                        currencyFormat}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </a>
        </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!services.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_parts_found.svg" alt="No Services Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'services.not_found.keyword.search' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'services.not_found' |
            translate}}
        </h4>
    </div>
</div>